import * as React from 'react'
import Stack from '@mui/material/Stack'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert, { AlertProps } from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import WarningIcon from '@svg/WarningIcon'
import theme from '@/theme'
import SealCheckIcon from '@svg/SealCheckIcon'
import { useLanguageContext } from '@/contexts/LanguageContext'

export enum notificationType {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success'
}
export interface Props {
  toastOpen?: boolean
  message?: string
  title?: string
  type?: notificationType
}
const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />
})

// const ToastMessage = () => {
const ToastMessage = ({ toastOpen, message, type, title }: Props) => {
  const [open, setOpen] = React.useState(toastOpen)
  const { translations } = useLanguageContext()

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }

  const getTitleDiv = (type: any) => {
    let icon
    let titleName
    let colors
    switch (type) {
      case notificationType.Success:
        icon = <SealCheckIcon />
        titleName = title || `${translations.SUCCESS_TITLE}`
        colors = theme.palette.success.main
        break
      case notificationType.Error:
        icon = <WarningIcon />
        titleName = title || `${translations.FAILED_TITLE}`
        colors = theme.palette.error.main
        break
      default:
        break
    }
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          color: colors
        }}
      >
        <Box sx={{ mr: '0.5rem', display: 'flex', alignItems: 'center' }}>{icon}</Box>
        <Typography variant='h5' fontWeight={600}>
          {titleName}
        </Typography>
      </Box>
    )
  }

  const titleDiv = getTitleDiv(type)

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert severity={type} sx={{ width: '100%', p: 2 }} variant='standard' icon={false}>
          <AlertTitle>{titleDiv}</AlertTitle>
          <Typography>{message}</Typography>
        </Alert>
      </Snackbar>
    </Stack>
  )
}
export default ToastMessage
